import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import { defaultMST3050_R01Filter, useMST3050_R01Store } from "./Store_MST3050_R01";
import { ChangeEvent, useCallback } from "react";
import useUiuxStore from "src/store/useUiuxStore";
import { getItemPopupList } from "src/apis/itemApi";
import { ItemDto } from "src/types/base";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";



export const SearchSection_MST3050_R01 = () => {

  const { brandCdList, itemGroupList, itemAccountList } = useCommonCodeStore();
  const { MST3050_R01Filter, setMST3050_R01Filter } = useMST3050_R01Store();
  const { setCodeSearchModalProps } = useUiuxStore();

  const itemCdHandleFoucsId = 'itemCd_search';

  const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'itemCd',
			category: '품목코드',
			focusId: itemCdHandleFoucsId,
			responseMapping: {
				itemCd: 'itemCd',
				itemNm: 'itemNm',
			},
			extraFilter: () => ({
				itemCd: MST3050_R01Filter.itemCd || '',
				itemNm: MST3050_R01Filter.itemNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: MST3050_R01Filter,
		setEditData: setMST3050_R01Filter,
		defaultData: defaultMST3050_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'MST3050_R01_search'
	});

  return (
	<SearchSectionForm>
		<SearchDropDownForm
			label="브랜드"
			value={MST3050_R01Filter.brandCd}
			optionList={brandCdList}
			// onChangeItem prop 사용, setBrandCd는 SysCodeDto를 받음
			onChangeItem={(selectedItem) => setMST3050_R01Filter({ brandCd: selectedItem?.minorCd || ''})}	
		/>
		<SearchDropDownForm
			label="품목그룹"
			value={MST3050_R01Filter.itemGroup}
			optionList={itemGroupList}
			onChangeItem={(selectedItem) => setMST3050_R01Filter({ itemGroup: selectedItem?.minorCd || ''})}
		/>
		<SearchCodeModalForm
			label="품목코드"
			value={MST3050_R01Filter.itemCd}
			valueLabel={MST3050_R01Filter.itemNm}
			onChange={getFieldHandlers('itemCd').onChange}
			onDoubleClick={getFieldHandlers('itemCd').onDoubleClick}
			onKeyDown={getFieldHandlers('itemCd').onEnterKeyDown}
		/>

	</SearchSectionForm>
  )
}